import facade, { type DesignFacade } from './facade';
import { getObservableProp, type NullablePartial } from 'utils/modules/state';

const defaults: NullablePartial<DesignFacade> = {
   isLoading: true,
};

export default function useDesignFacade() {
   return {
      state: new Proxy<DesignFacade>({} as DesignFacade, {
         get: (target, prop: keyof DesignFacade) => {
            return getObservableProp(facade, defaults, prop);
         },
      }),
      api: facade.api,
   };
}
